import { render, staticRenderFns } from "./add-files.vue?vue&type=template&id=108a9a33&scoped=true"
import script from "./add-files.vue?vue&type=script&lang=js"
export * from "./add-files.vue?vue&type=script&lang=js"
import style0 from "./add-files.vue?vue&type=style&index=0&id=108a9a33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108a9a33",
  null
  
)

export default component.exports